import {NavigablePage} from '../../interfaces/navigation/navigable-page.interface';
import {TvShopStateService} from '../../services/state/tv-shop-state.service';

export class NavigationUtil {
  public static processNavigationPage(pageConfiguration: NavigablePage, stateService: TvShopStateService, yOffset = 0): NavigablePage {
    pageConfiguration.navigableComponents.map((navigableComponent) => {
      if (navigableComponent.process(stateService)) {
        navigableComponent.shouldShowComponent = true;
        navigableComponent.yPosition = yOffset;
        yOffset++;
      }
      return navigableComponent;
    })
    return pageConfiguration;
  }
}
